// import { Box, Button, Grid, IconButton, Modal, Tooltip, Typography } from '@mui/material';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import React, { useCallback, useState, useEffect } from 'react';
// import axios from 'axios';
// import DocsCard from './DocsCard';
// import CreateDocs from './CreateDocs';
// import useModal from '../../hooks/useModal';
// import useErrorHandler from '../../hooks/useErrorHandler';

// const Docs = () => {
//     const [docs, setDocs] = useState(null);
//     const { modalState, openModal, closeModal } = useModal();
//     const errorHandler = useErrorHandler();
//     const [doc, setDoc] = useState(null);
//     const [isCopying, setIsCopying] = useState(false);

//     const fetchDocs = useCallback(async () => {
//         try {
//             const response = await axios.get('/hr/docs');
//             setDocs(response.data.docs);
//         } catch (e) {
//             errorHandler(e);
//         }
//     }, [errorHandler]);

//     const editDoc = id => {
//         setDoc(id);
//         setIsCopying(false); // Set to false for editing
//         openModal();
//     };

//     const copyDoc = id => {
//         setDoc(id);
//         setIsCopying(true); // Set to true for copying
//         openModal();
//     };

//     useEffect(() => {
//         fetchDocs();
//     }, [fetchDocs]);

//     return (
//         <Box  sx={{ backgroundColor: 'background.main' , px:2 , py :3 }}>
//             <Box >
//                 <Grid container spacing={4} display='flex' alignItems='center' className="pb-1">
//                     <Grid item xs>
//                         <div >
//                             <h1 className="text-2xl text-neutral-500">Docs</h1>
//                         </div>
//                     </Grid>

//                     <Grid item display='flex' alignItems='center' gap={2}>
//                         <Box>
//                             <Button
//                                 variant='contained'
//                                 onClick={() => {
//                                     setDoc(null);
//                                     setIsCopying(false); // Ensure creating a new doc
//                                     openModal();
//                                 }}>
//                                 Create Docs
//                             </Button>
//                         </Box>

//                         <Box>
//                             <Tooltip title='info' placement='top'>
//                                 {/* <IconButton disableRipple variant='navIcon' sx={{ mr: 0, ml: 2 }}> */}
//                                     {/* <InfoOutlinedIcon fontSize='small' /> */}
//                                     <InfoOutlinedIcon />
//                                 {/* </IconButton> */}
//                             </Tooltip>
//                         </Box>
//                     </Grid>
//                 </Grid>
//             </Box>
//             {docs?.map(doc => (
//                 <DocsCard
//                     key={doc._id}
//                     id={doc._id}
//                     title={doc.title}
//                     content={doc.content}
//                     joblistings={doc.joblistings}
//                     refresh={fetchDocs}
//                     editDoc={editDoc}
//                     copyDoc={copyDoc}
//                 />
//             ))}
//             <Modal
//                 sx={{
//                     overflowY: 'scroll',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                 }}
//                 open={modalState}
//                 onClose={closeModal}>
//                 <CreateDocs
//                     closeModal={closeModal}
//                     refresh={fetchDocs}
//                     doc={doc}
//                     isCopying={isCopying}
//                 />
//             </Modal>
//         </Box>
//     );
// };

// export default Docs;
import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { useCallback, useState, useEffect, useRef } from "react";
import axios from "axios";
import DocsCard from "./DocsCard";
import CreateDocs from "./CreateDocs";
import useModal from "../../hooks/useModal";
import useErrorHandler from "../../hooks/useErrorHandler";
import { IoSearch } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
const Docs = () => {
  const [docs, setDocs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Pagination: current page
  const [totalPages, setTotalPages] = useState(1); // Pagination: total pages
  const { modalState, openModal, closeModal } = useModal();
  const errorHandler = useErrorHandler();
  const [doc, setDoc] = useState(null);
  const [isCopying, setIsCopying] = useState(false);
const [searchQuery, setSearchQuery] = useState("");

  const fetchDocs = useCallback(
    async (page = 1) => {
      try {
        const response = await axios.get(
          `/hr/docs?page=${currentPage}&limit=10`
        ); // Pagination: passing page & limit
        setDocs(response.data.docs);
        setTotalPages(response.data.pageData.totalPages); // Set total pages from response
        setCurrentPage(response.data.pageData.currentPage); // Update current page
      } catch (e) {
        errorHandler(e);
      }
    },
    [currentPage]
  );

  const editDoc = (id) => {
    setDoc(id);
    setIsCopying(false); // Set to false for editing
    openModal();
  };

  // const copyDoc = (id) => {
  //   setDoc(id);
  //   setIsCopying(true); // Set to true for copying
  //   openModal();
  // };

  useEffect(() => {
    fetchDocs(currentPage); // Fetch docs for current page on mount
  }, [fetchDocs, currentPage]);

  const filteredRows = docs?.filter((row) =>
    row.title.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const [placeholder, setPlaceholder] = useState("Search");
  const inputRef = useRef(null);
  const updatePlaceholder = () => {
    // Ensure the ref is not null before trying to access offsetWidth
    if (inputRef.current) {
      if (inputRef.current.offsetWidth > 200) {
        // Adjust width threshold as needed
        setPlaceholder("Search document");
      } else {
        setPlaceholder("Search");
      }
    }
  };

  useEffect(() => {
    // Check on mount
    updatePlaceholder();

    // Add event listener to handle resizing
    window.addEventListener("resize", updatePlaceholder);
  }, [updatePlaceholder]);

  return (
    <Box
      sx={{  px: {md:2,xs:1}, py: 3, height: "88vh", marginBottom: "60px" }}
    >
      {docs?.length > 0 ? (
        <Box>
          <div className="flex items-center gap-2 justify-end">
            <Box className="flex w-[134px] md:w-[400px] h-[40px] px-[10px] items-center justify-between border border-[#1F1F1F] rounded-md">
              <input
                type="text"
                className="w-full bg-transparent outline-none text-[14px] placeholder:text-[14px]"
                ref={inputRef}
                placeholder={placeholder}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <div>
                <IoSearch />
              </div>
            </Box>

            <button
              variant="contained"
              onClick={() => {
                setDoc(null);
                setIsCopying(false);
                openModal();
              }}
              style={{
                height: "40px",
                width: "142px",
                backgroundColor: "#0080FF",
                color: "#fff",
              }}
              className="w-max rounded-[5px] text-[14px] hidden sm:block p-2"
            >
              Create Docs
            </button>

            <div
              className="bg-[#0080FF] sm:hidden flex justify-center w-[41px] h-[40px] items-center rounded-[5px]"
              onClick={openModal}
            >
              <IoMdAdd color="#fff" />
            </div>
          </div>

          {/* Docs List */}
          {filteredRows?.map((doc) => (
            <DocsCard
              key={doc._id}
              id={doc._id}
              title={doc.title}
              content={doc.content}
              joblistings={doc.joblistings}
              refresh={fetchDocs}
              editDoc={editDoc}
              // copyDoc={copyDoc}
            />
          ))}
        </Box>
      ) : (
        // <div className="flex gap-3 flex-col items-center justify-center text-center mt-[100px] mb-[60px]">

        <div className="w-full md:h-[80vh] h-[65vh] flex justify-center items-center">
          <div className="flex justify-center gap-3 flex-col items-center p-2 w-full h-full">
            <img
              src="/images/no-docs.png"
              alt="No Record"
              className="h-[130px] md:h-[200px]"
            // className="mb-1"
            // style={{ maxWidth: "30%", margin: "auto" }}
            />
            <h1 className="text-[16px] md:text-[22px]">
              No docs available!
            </h1>
            <p className="text-[14px] md:text-[16px] text-[#868686] text-center w-[90%] md:w-[40%]">
              You have no docs available at the moment. Click on the “Create
              Docs” button now to create new docs.
            </p>
            <button
              onClick={openModal}
              className="text-white text-[14px] md:text-base py-2 h-fit md:py-2 px-2 md:px-3 rounded-lg bg-[#0080FF]"
            >
              Create Docs
            </button>
          </div>
        </div>
      )}

      {/* Pagination Controls */}
      {/* <Box display="flex" justifyContent="center" mt={3}>
        <Button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          Previous
        </Button>

        <Typography variant="body2" sx={{ mx: 2 }}>
          Page {currentPage} of {totalPages}
        </Typography>

        <Button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          Next
        </Button>
      </Box> */}

      <Modal
        sx={{
          overflowY: "scroll",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        open={modalState}
        onClose={closeModal}
      >
        <CreateDocs
          closeModal={closeModal}
          refresh={fetchDocs}
          doc={doc}
          isCopying={isCopying}
        />
      </Modal>
    </Box>
  );
};

export default Docs;
